<template>
  <div>
    <div class="top-nav"></div>
<!--    <div class="immersion-bottom-left"></div>-->
<!--    <div class="immersion-left-center"></div>-->
<!--    <div class="immersion-right-center"></div>-->
<!--    <div class="immersion-bottom-right"></div>-->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@mixin background-com {
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.top-nav {
  width: 100%;
  height: 1.42rem;
  background-image: url("../assets/img/top-nav.png");
  @include background-com();
  position: absolute;
  top: 0;
  left: 0;
}

</style>